module.exports = __webpack_public_path__ + "static/media/canola_field.cad270c0.jpeg";